import $ from 'jquery';
import React, {useEffect, useState, Fragment} from 'react';
import ReactDOM from 'react-dom';
import Config from '../utils/config';
import '../utils/global';
import { dispatchAlert, displayRedirectAlert } from '../utils/site-utils';
import * as athenaPopups from '../utils/athenaPopups';
import {AutoRefreshLoginCheckin, StopLoginCheckin, AutoCheckUM, checkWindowInfo, setBodyCss} from '../utils/NewIndexHelp';
import TopNavigation from '../AfterLoginNavigation/topNavigation';
import News from './news';
import Time from './time';
import Sportsbook from './sportsbook';
import TurnMobile from './popupTurnMobile';
import TransBar from './popupTransBar';
import UMPopup from './uMPopup';
import PhaseOut from './phaseOut';
import Login3 from '../Login/views/loginV3';
import LoginModal from '../Login/views/loginModal';
import { GetQueryString, RemoveQueryString, AddQueryString, toOneElementArray, checkMobileAgent, getFullUrlPath, setToKafka } from '../utils/common';
import { getCookie, setCookie } from '../utils/cookie';
import { IsThirdPartyPopup, PopupThirdPartyDiv, NOpenKenoWindow, OpenDepositPage,  OpenExchange } from '../thirdParty/NT3rdFun';
import Label from '../utils/label';
import Alert from './alert';
import {isRestricted, BrowserRestrictWarning} from './BrowserUpgrade';

import Products from '../AthenaComponent/products';
import Visual2 from '../AthenaComponent/visual2';
import Footer from '../AthenaComponent/footer';
import Casino from '../AthenaComponent/casino';
import Header from '../AthenaComponent/header';
import Signup from '../AthenaComponent/popupSignup';
import Forget from '../AthenaComponent/popupForgot';
import PopupKycReupload from '../AthenaComponent/popupKycReupload';
import PopCongra from '../AthenaComponent/popupCongra';
import CusFooter from '../AthenaComponent/footerCustom';
import FooterDemo from '../AthenaComponent/footerDemo';
import LiveChatWidgetWrap from '../AthenaComponent/liveChatWidgetWrap';
import Out_Visual2 from '../AthenaComponent/visual2';
import Out_Products from '../AthenaComponent/products';
import Out_Footer from '../AthenaComponent/footer';
import Out_CusFooter from '../AthenaComponent/footerCustom';
import Out_Casino from '../AthenaComponent/casino';
import CustBlock from '../AthenaComponent/custBlock';
import CasinoProducts from '../AthenaComponent/casinoProducts';
import MainMenu from '../AthenaComponent/mainMenu';
import ChinaviewTerminate from './ChinaviewTerminate';

let autoUM = 0, autoLoginCheckin = 0;
let gid = Date.now();
/*
const Products = window.AthenaCom_products;
const Visual2 = window.AthenaCom_visual2;
const Footer = window.AthenaCom_footer;
const Casino = window.AthenaCom_Casino;
const CusFooter = window.AthenaCom_CusFooter;
const FooterDemo = window.AthenaCom_FooterDemo;
//const Out_Visual2 = window.AthenaCom_visual2;
const Out_CusFooter = window.AthenaCom_CusFooter;
const Out_Products = window.AthenaCom_products;
const Out_Footer = window.AthenaCom_footer;
const Out_Casino = window.AthenaCom_Casino;

//const Login3 = window.AthenaCom_Login3;
//const LoginModal = window.AthenaCom_LoginModal;
const Header = window.AthenaCom_Header;
const Signup = window.AthenaCom_Signup;
const Forget = window.AthenaCom_Forget;
const PopCongra = window.AthenaCom_PopCongra;
const LiveChatWidgetWrap = window.AthenaCom_LiveChatWidgetWrap;
const CustBlock = window.AthenaCom_CustBlock;
const CasinoProducts = window.AthenaCom_CasinoProducts;
const RingCasinoLobby = window.AthenaCom_RingCasinoLobby;
const MainMenu = window.AthenaCom_MainMenu;
*/

if (Config.appConfig.checkWindow) {
	checkWindowInfo();
}
//Liva Chat
if (Label.lbl_livechatForNA != '') {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.text = Label.lbl_livechatForNA;
	console.log(script);
	document.getElementsByTagName('head')[0].appendChild(script);
}

const MenuTabEnum = Object.freeze({
	Sports:0,
	Home:1,
});

const MenuTabMap = new Map([
	['tab02', 0],
	['tab01', 1]
]);

export default function AthenaAppMain () {

	const [SelectedTab, setSelectedTab] = useState("");
	const [ActPara, setActPara] = useState("");
	const [OpenDivType, setOpenDivType] = useState(-1);
	const [WebSkinType, setWebSkinType] = useState('');
	const [JumpToOldView, setJumpToOldView] = useState(false);
	const [ShowBrowserUpgrade, setBrowserUpgrade] = useState(true);
	const [isShowJupiterPromotion, setIsShowJupiterPromotion] = useState(false);
	const isAthena = Config.appConfig.IsAthena;
	const Logined = Config.appConfig.Logined;
	const accountCansee = JSON.parse(Config.appConfig.getAccountMenu);
	const allowWebskinTypes = Config.appConfig.WebSkinTypeAllow.split(',');
	const hasGalaxy = allowWebskinTypes.includes('7');
	const hasMars = allowWebskinTypes.includes('8');

	useEffect(() => {
		const init = () => {
			displayRedirectAlert();

			if (isAthena && !Logined && Config.appConfig.TurnToMobile && checkMobileAgent()) {
				const src = GetQueryString('src');
				const subDmoain = Config.appConfig.SiteID != "4200800" ? "smart." : "m.";
				if (src == null || src == 'undefined' || src != 'm') {
					location.replace(
						'//' + subDmoain + Config.appConfig.DomainName + '/' + window.location.search
					);
					return;
				}
			}
			
			let finalSkinType = Config.appConfig.webSkinType,
				DivIndex = -1,
				urlpara = '',
				currMainPage = '',
				act_webskintype = GetQueryString('WebSkinType'),
				EnableAsia = Config.appConfig.EnableAsia,
				EnableEuro = Config.appConfig.EnableEuro,
				EnableChinaAsia = Config.appConfig.EnableChinaAsia,
				EnableLicensee2 = Config.appConfig.EnableLicensee2,
				EnableTablet = Config.appConfig.EnableTablet,
				Enable188China = Config.appConfig.Enable188China,
				WebSkinTypeDefault = Config.appConfig.WebSkinTypeDefault,
				targetMenuTab = parseInt(GetQueryString('targetmenutab'));
			
			if(act_webskintype){
				if(act_webskintype === '0' && !EnableAsia) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '1' && !EnableEuro) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '2' && !EnableChinaAsia) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '3' && !EnableLicensee2) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '4' && !EnableTablet) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '6' && !Enable188China) {
					act_webskintype = WebSkinTypeDefault;
				}
				finalSkinType = act_webskintype;
			}
			
			/*if(finalSkinType === "1" && Config.appConfig.SiteID == "4200800") {
				window.location.href = "EntryIndex/OpenSports?webskintype=1";
			}*/
			
			let act = GetQueryString('act'),
				isInnerSwitchAsia = Config.appConfig.InnerSwitchAsia;
			
			currMainPage = getCookie(setCurrMainTab);
			// given defualt tab
			if (currMainPage == null || currMainPage == 'undefined' || currMainPage == 'null') {
				currMainPage = 'Tab01';
			}
			
			if (act == 'cong') {
				DivIndex = 3;
				act = '';
			} else if (act == 'reg') {
				DivIndex = !Logined ? 0 : -1;
				act = '';
				currMainPage = 'Tab01';
			} else if (act == 'forget') {
				DivIndex = !Logined ? 1 : -1;
				act = '';
			} else if (act.toLowerCase() == 'home') {
				currMainPage = 'Tab01';
			} else if(finalSkinType === "4") {
				urlpara = window.location.search.replace('?', '');
				urlpara = RemoveQueryString("webskintype", urlpara);
				urlpara = AddQueryString('webskintype=' + finalSkinType, urlpara);
				window.location.href = "EntryIndex/OpenSports?" + urlpara;
			} else if (DivIndex == -1 && (act || act_webskintype)) {
				currMainPage = 'Tab02';
				urlpara = window.location.search.replace('?', '');
			} else {
				let menu = Config.appConfig.MenuData;
				let tab = $.grep(menu, e => e.TabName == currMainPage);
				if (!(tab.length > 0 && (tab[0].OpenType == '0' || tab[0].OpenType == '3'))) {
					currMainPage = null;
				} else {
					if (tab[0].URL) {
						let url = tab[0].URL;
						if (url.indexOf('?', 0) == -1) {
							url = 'act=' + url;
						} else {
							url = url.replace('?', '');
						}
						act = url;
						urlpara = act;
					}
				}
				if (currMainPage == null || currMainPage == 'undefined' || currMainPage == 'null') {
					currMainPage = menu.length > 0 ? menu[0].TabName : 'Tab02';
				}
			}
	
			if (!act && !act_webskintype) {
				let LastSportType = getCookie('setLastSportType');
				if (LastSportType == null || LastSportType == 'undefined') {
					urlpara = 'act=sports';
				} else {
					urlpara = LastSportType;
				}
			}
	
			if (!act_webskintype) {
				urlpara = RemoveQueryString("webskintype", urlpara);
				urlpara = AddQueryString('webskintype=' + finalSkinType, urlpara);
			}
			
			setCookie(setCurrMainTab, currMainPage);
			setCookie(setShowMainTab, currMainPage);
		
			if(urlpara.toLowerCase().indexOf('webskintype') === -1) {
				urlpara = urlpara + '&webskintype=' + finalSkinType;
			}

			if(urlpara.toLowerCase().indexOf('lang') === -1) {
				urlpara = urlpara + '&lang=' + Config.appConfig.UserLang;
			}

			switch (targetMenuTab) {
				case MenuTabEnum.Home:
					currMainPage = 'Tab01';
				default:
					break;
			}
			
			gid =  '&gid=' + Config.appConfig.GUID+gid;

			setSelectedTab(currMainPage);
			setActPara(urlpara);
			setOpenDivType(DivIndex);
			setWebSkinType(finalSkinType);
			setCookie(setCurrMainTab, currMainPage);
			setCookie(setShowMainTab, currMainPage);
		}
		init();
	}, [])

	const openKenoLottery = () => {
		let lang = Config.appConfig.UserLang,
			data = JSON.parse(Config.appConfig.KenoLottery),
			msg = Label.lbl_KenoLotteryNoDeposit,
			flashMsg = Label.lbl_KenoLotteryFlashMsg,
			RES_BlockPopMsg = Label.lbl_BlockPopMsg;
		NOpenKenoWindow(lang, data, msg, flashMsg, RES_BlockPopMsg, Config.appConfig.ActStatus);
	}

	const openKenoTableGame = () => {
		let lang = Config.appConfig.UserLang,
			data = JSON.parse(Config.appConfig.TableGame),
			msg = Label.lbl_TableGameNoDeposit,
			flashMsg = Label.lbl_TableGameFlashMsg,
			RES_BlockPopMsg = Label.lbl_BlockPopMsg;
		NOpenKenoWindow(lang, data, msg, flashMsg, RES_BlockPopMsg, Config.appConfig.ActStatus);
	}

	const openNewKenoWindow = () => {
		let lang = Config.appConfig.UserLang,
			data = JSON.parse(Config.appConfig.Keno),
			msg = Label.lbl_KenoNoDeposit,
			flashMsg = Label.lbl_KenoFlashMsg,
			RES_BlockPopMsg = Label.lbl_BlockPopMsg;
		NOpenKenoWindow(lang, data, msg, flashMsg, RES_BlockPopMsg, Config.appConfig.ActStatus);
	}

	const openVGamingCasinoWin = type => {
		const data = (
			type === 'vgaming' ? { cust: 'vgaming', isEnabled: Config.appConfig.CanSeeVGaming, windowName: 'VGaming' } : 
			type === 'vgamingmobi' ? { cust: 'vgaming', isEnabled: Config.appConfig.CanSeeVGamingMobi, windowName: 'VGamingMobi' } :
			{ cust: 'onerng-casino', CanSeeCasino: accountCansee.CanSeeCasino }
		);

		NOpenKenoWindow(
			Config.appConfig.UserLang,
			data,
			Label.lbl_PromptLoginDetail1,
			Label.lbl_casino_alert,
			'',
			Config.appConfig.ActStatus
		);
	};

	const openDepositPage = (opentype) => {
		OpenDepositPage(opentype, Config.appConfig.CustomTitle);
	}

	const openDepositPageFromEvent = (e, obj) => {
		openDepositPage(obj.key);
		//OpenDepositPage(obj.key, Config.appConfig.CustomTitle);
	}

	const selectTab = (id, openType, url, size, switchWebSkinType) => {
		const SelectedTab = id;
		let finalSkinType = WebSkinType || switchWebSkinType;
		const openId = id.toLowerCase().replace('tab', '');

		if (openType === 0 && 
			url.toLowerCase().indexOf('webskintype', 0) > -1
		) {
			url = '?webskintype=' + finalSkinType;
			setWebSkinType(finalSkinType);
			setCookie('setSportsTab', id);
		}else if (openType == 3) { //deep link
			var tabid = getCookie('setSportsTab');
			if (!tabid) {
				tabid = 'Tab02';
			}
		}

		if (
			openType == 0 &&
			url.toLowerCase().indexOf('webskintype', 0) == -1 &&
			id != 'Tab02' &&
			OpenDivType == 5
		) {
			popupDiv(-1);
		}

		switch (openType) {
			case 0: //inner
				if (url.indexOf('?', 0) == -1) {
					url = 'act=' + url;
				} else {
					url = url.replace('?', '');
					const act = GetQueryString('act', url);
					const LastSport = act == '' ? 'act=sports' : 'act=' + act;
					setCookie('setLastSportType', LastSport);
				}
				setSelectedTab(SelectedTab),
				setActPara(url)
				setCookie(setCurrMainTab, SelectedTab);
				setCookie(setShowMainTab, SelectedTab);
				break;
			case 1: //popup
				url = url.replace('{0}', Config.appConfig.DomainName);
				athenaPopups.AT_openBrWindow(openId, url, size, size);
				break;
			case 2: //exec JS Function
				switch(url){
					case 'OpenExchange':
						OpenExchange(Config.appConfig.ActStatus);
						break;
					case "_OpenNewKenoWindow()":
						openNewKenoWindow();
						break;
					case 'OpenESportsWeb':
						popupDiv("esports");
						break;
					case "OpenVGaming":
						openVGamingCasinoWin('vgaming');
						break;
					case "OpenVGamingMobi":
						openVGamingCasinoWin('vgamingmobi');
						break;
					case 'OpenCasino':
						openVGamingCasinoWin('onerng-casino');
						break;
				}
				break;
			case 3: //open left menu game
				if (url.indexOf('?', 0) == -1) {
					url = 'act=' + url;
				} else {
					url = url.replace('?', '');
				}
				setActPara(url);
				let tabid = getCookie('setSportsTab');
				if (!tabid) {
					tabid = 'Tab02';
				}
				setSelectedTab(tabid);
				setCookie(setCurrMainTab, tabid);
				setCookie(setShowMainTab, SelectedTab);
				const LastSport = url == '' ? 'act=sports' : url;
				setCookie('setLastSportType', LastSport);
				break;
		}
	}

	const enableTabComponent = (key) => {
		try {
			if (WebSkinType === '1' && key != 'Sportsbook') {
				return false;
			}
			const tab = SelectedTab;
			const tabComList = Config.appConfig.TabComList;
			const coms = $.grep(tabComList, e => e.key['@id'].toLowerCase() == tab.toLowerCase());
			if (coms.length == 0) {
				return false;
			}

			// coms[0]['key']['ComArray'] 不是 array 的話把它變成一個 array
			if(!Array.isArray(coms[0]['key']['ComArray'])) {
				coms[0]['key']['ComArray'] = toOneElementArray(coms[0]['key']['ComArray']);
			}
			const com = $.grep(coms[0]['key']['ComArray'], e => e.toLowerCase() == key.toLowerCase());
			if (com.length == 0) {
				return false;
			}

			return true;
		} catch (ex) {
			console.error(ex);
			return false;
		}
	}

	const isShowTimeAndNews = () => {
		try {
			if (WebSkinType == '3' && SelectedTab == 'Tab02') {
				return false;
			}

			if (WebSkinType == '2' || WebSkinType == '6'){
				return false;
			}

			return true;
		} catch (ex) {
			return true;
		}
	}


	const popupDiv = (type, para1, para2) => {
		if (IsThirdPartyPopup(type)) {
			PopupThirdPartyDiv(type, para1, para2);
		}
		else {
			if(type === 0) {
				set_ActPara('reg');
			}
			else {
				setOpenDivType(type);
			}
		}
	}

	const set_ActPara = (para) => {
		const menu = Config.appConfig.MenuData;
		if(para === "reg") {
			for (let i = 0; i < menu.length; i++) {
				if ("tab01" === menu[i].TabName.toLowerCase()) {
					selectTab(menu[i].TabName, menu[i].OpenType, para, menu[i].Size);
					setOpenDivType(0);
				}
				return;
			}
		}
		else {
			const innerSwitchAsia = Config.appConfig.InnerSwitchAsia;
			const enableLicensee2 = Config.appConfig.EnableLicensee2;
			const tab = getCookie(setCurrMainTab);
			if(menu) {
				for (let i = 0; i < menu.length; i++) {
					const url = menu[i].URL.toLowerCase();
					var val = enableLicensee2 ? '?webskintype=3' : '?webskintype=0';
					if(!innerSwitchAsia) {
						val = '?webskintype=' + (WebSkinType ? WebSkinType : '0');
					}
					if (url == 'sports' || url == val) {
						if (tab != menu[i].TabName) {
							selectTab(menu[i].TabName, menu[i].OpenType, para, menu[i].Size);
						}
						return;
					}
				}
			}
			selectTab('Tab02', 0, para, '1');
		}
	}

	const deepLink = (e, key) => {
		switch(key.act) {
			case "DeepLeague":
				if(document.getElementById("sportsFrame") != null && document.getElementById("sportsFrame") != 'undefined') {
					document.getElementById("sportsFrame").contentWindow.postMessage(
						{
							mode:"dp",
							data :    {
							   leagueid:key.leagueid,
							   sportid:key.sportid,
							   menuType:key.menuType
							}
						}, 
						"*"
					);
				} 
				else {
					set_ActPara(key.sportid + "&leaguekey" + key.leagueid 
					+ "&menuType" + key.menuType + "&" + new Date().getTime());
				}
				break;
			case "NPHP":
				if(document.getElementById("sportsFrame") != null && document.getElementById("sportsFrame") != 'undefined') {
					document.getElementById("sportsFrame").contentWindow.postMessage("enterNPHP", "*");
				} 
				else {
					set_ActPara(key.act + "&" + new Date().getTime());
				}
				break;
			case "Statement":
				if(WebSkinType === '2')
				{
					if(document.getElementById("sportsFrame") != null && document.getElementById("sportsFrame") != 'undefined') {
						document.getElementById("sportsFrame").contentWindow.postMessage("nphpStatement", "*");
					}
					else {
						set_ActPara(key.act + "&" + new Date().getTime());
					}
				} 
				else {
					openDepositPage("5");
				}
				break;
			default:
				set_ActPara(key.act + "&" + new Date().getTime());
				break;
		}
	}

	const changeOddsType = (e, obj) => {
		$.ajax({
			type: 'POST',
			url: getFullUrlPath('EntryIndex/SetOddsType'),
			data: { OddsType: obj.oddsType }
		});
	}

	const changeDarkmode = (e, obj) => {
		$.ajax({
			type: 'POST',
			url: getFullUrlPath('EntryIndex/SetDarkMode'),
			data: { isDarkMode: obj.isDarkMode }
		});
	}
	
	const changeLanguage = (e, obj) => {
		$.ajax({
			type: 'POST',
			url: getFullUrlPath('ChangeLanguage.aspx'),
			data: { hidSelLang: obj.key, hidIsLogin: Logined },
			success: refreshPage => {
				window.location.href = refreshPage;
			}
		});
	}

	const setStateForSkinType = (e, obj) => {
		if(WebSkinType != obj.key) {
			popupDiv(6);
		}
		let oldWebSkinType = WebSkinType == "" ? GetQueryString('WebSkinType') : WebSkinType;
		if (obj.key === '0') {
			setJumpToOldView(true, () => setJumpToOldView(false));
		}
		if(oldWebSkinType === "1" && obj.key !== "1") {
			if(Config.appConfig.SiteID == "4200800") {
				window.location.href = "../NewIndex?webskintype=" + obj.key;
				return;
			}
		}
		setWebSkinType(obj.key);
		let tabid = 'Tab02';
		let isInnerSwitchAsia = Config.appConfig.InnerSwitchAsia;
		if(!isInnerSwitchAsia && obj.key === "3") {
			tabid = 'Tab03';
		}
		const url = window.location.href;

		if (window.history.pushState) {
			let newQueryString = "";
			let tmpArray = url.split("?");
			const baseURL = tmpArray[0];
			const queryString = tmpArray[1];
			if (queryString) {
				tmpArray = queryString.split("&");
				tmpArray.forEach(query => {
					if (query.split('=')[0].toLowerCase() != "webskintype") {
						newQueryString += query + "&";
					}
				});
			}

			newQueryString += "webskintype=" + obj.key;
			const newUrl = baseURL + "?" + newQueryString;
			if (obj.key === '7') {
				redirectToGalaxy(obj);
				return;
			}
			if (obj.key === '8') {
				redirectToMars(obj);
				return;
			}
			window.history.pushState({ path: newUrl }, '', newUrl);
		}
		
		selectTab(tabid, 0, '?WebSkinType=' + obj.key, 1, obj.key);
	}
	const redirectToMars = (obj) => {
		let quertyString = window.location.search.replace('?', '');
		const tab = getCookie(setCurrMainTab);
		quertyString = RemoveQueryString("webskintype", quertyString);
		quertyString = AddQueryString('webskintype=8', quertyString);
		quertyString = RemoveQueryString("act", quertyString);
		quertyString = AddQueryString(`act=${obj.sportId}`, quertyString);
		if(obj.leagueId){
			quertyString = AddQueryString(`LeagueId=${obj.leagueId}`, quertyString);
		}
		if(obj.sport){
			quertyString = AddQueryString(`SportId=${obj.sport}`, quertyString);
		}
		quertyString = RemoveQueryString("targetmenutab", quertyString);
		quertyString = AddQueryString(`targetmenutab=${MenuTabMap.get(tab.toLowerCase())}`, quertyString);

		let requestUrlString = getFullUrlPath(`NewIndex?${quertyString}`);
		window.location.href = requestUrlString;
	}
	const redirectToGalaxy = (obj) => {
		let quertyString = window.location.search.replace('?', '');
		const tab = getCookie(setCurrMainTab);
		quertyString = RemoveQueryString("webskintype", quertyString);
		quertyString = AddQueryString('webskintype=7', quertyString);
		quertyString = RemoveQueryString("act", quertyString);
		quertyString = AddQueryString(`act=${obj.sportId}`, quertyString);
		if(obj.leagueId){
			quertyString = AddQueryString(`LeagueId=${obj.leagueId}`, quertyString);
		}
		if(obj.sport){
			quertyString = AddQueryString(`SportId=${obj.sport}`, quertyString);
		}
		quertyString = RemoveQueryString("targetmenutab", quertyString);
		quertyString = AddQueryString(`targetmenutab=${MenuTabMap.get(tab.toLowerCase())}`, quertyString);

		let requestUrlString = getFullUrlPath(`NewIndex?${quertyString}`);
		window.location.href = requestUrlString;
	}
	
	const openPopupDiv = (e, obj) => {
		popupDiv(obj.key, obj.para1, obj.para2);
	}

	const handleKeyDown = (e) => {
		if (e.keyCode === 27) {
			//// Detect escape key and close dialog window.
			setOpenDivType(-1);
		}
	}

	useEffect(()=>{
		const DidMount = () => {
			$(document.body).on('keydown', handleKeyDown);
			$('#clickBtnBySkinType').on('click', setStateForSkinType);
			$('#clickBtnByPopupType').on('click', openPopupDiv);
			$('#clickBtnByOpenDeposit').on('click', openDepositPageFromEvent);
			$('#clickBtnByStopLoginCheckin').on('click', StopLoginCheckin);
			$('#clickBtnByChangeLanguage').on('click', changeLanguage);
			$('#clickBtnByDeepLink').on('click', deepLink);
			$('#clickBtnByChangeOddsType').on('click', changeOddsType);
			$('#clickBtnByChangeDarkmode').on('click', changeDarkmode);
			$('#clickBtnByOpenKeno').on('click', openNewKenoWindow);
			$('#clickBtnByOpenKenoLotterty').on('click', openKenoLottery);
			$('#clickBtnByOpenKenoTableGame').on('click', openKenoTableGame);
			StopLoginCheckin(autoUM, autoLoginCheckin);
			autoUM = setInterval(AutoCheckUM, 300000); 
			if (Logined) {
				AutoRefreshLoginCheckin(Config.appConfig.CheckURL, Config.appConfig.IUserName, autoUM, autoLoginCheckin);
				autoLoginCheckin = setInterval(() => {
					AutoRefreshLoginCheckin(Config.appConfig.CheckURL, Config.appConfig.IUserName, autoUM, autoLoginCheckin);
				}, 60000);
			}
			else {
				//Display singin, 
			}

			if (localStorage.getItem('_doNotShowJupiterPromotion') !== '1' && 		(hasGalaxy || hasMars)
			) {
				document.body.style.backgroundPositionY = "56px";
				setIsShowJupiterPromotion(true);
			}
					
			// var self = this;
			$(document).ready(() => {
				if (Logined && Config.appConfig.FPSIsUse) {
					let __timerId = setInterval(postFPSTransaction, 2000);
					function postFPSTransaction() {
						const status = $('#fps-script').attr('data-status');
						const __di = document.getElementById('__di');
						const frm = $('#FormFps');
						if (status === 'idle') return;
                        if ((__di && __di.value != '') || status === 'error') {
							$.ajax({
								type: 'POST',
								url: getFullUrlPath('GquIboemfs.aspx'),
								data: frm.serialize()
							});
							clearInterval(__timerId);
						}
					}
				}
			});
			
			changeCss();
		}
		DidMount();
		return()=>{
			$(document.body).off('keydown', handleKeyDown);
			$('#clickBtnBySkinType').off('click', setStateForSkinType);
			$('#clickBtnByPopupType').off('click', openPopupDiv);
			$('#clickBtnByOpenDeposit').off('click', openDepositPageFromEvent);
			$('#clickBtnByStopLoginCheckin').off('click', StopLoginCheckin);
			$('#clickBtnByChangeLanguage').off('click', changeLanguage);
			$('#clickBtnByDeepLink').off('click', deepLink);
			$('#clickBtnByChangeOddsType').off('click', changeOddsType);
			$('#clickBtnByChangeDarkmode').off('click', changeDarkmode);
			$('#clickBtnByOpenKeno').off('click', openNewKenoWindow);
			$('#clickBtnByOpenKenoLotterty').off('click', openKenoLottery);
			$('#clickBtnByOpenKenoTableGame').off('click', openKenoTableGame);
			StopLoginCheckin(autoUM, autoLoginCheckin);
		}
	},[changeCss])

	useEffect(()=>{
		/*if (SelectedTab == "Tab01" && (Config.appConfig.SiteID == "4218900")) {
			let alertMsg = "";
			switch (Config.appConfig.SiteID) {
				case "4218900":
					alertMsg = Label.lbl_OpalAlert;
					break;
				case "4218400":
					alertMsg = Label.lbl_IvoryBetAlert;
					break;
			}
			setTimeout(() => {
				dispatchAlert(alertMsg.replace(/<br\s*\/?>/mg,"\n"));
			}, 100)
		}*/
		changeCss();
	},[SelectedTab, WebSkinType, Config])

	const changeCss = () => {
		let css = "";
		const realWebSkinType = WebSkinType.toString();
		if(SelectedTab.toLowerCase() == "tab02" || (!Config.appConfig.InnerSwitchAsia && SelectedTab.toLowerCase() == "tab03"))
		{
			css = SelectedTab + ((realWebSkinType === '3' || realWebSkinType === '2' || realWebSkinType === '6') ? ' rwd noNews' : '') + (realWebSkinType === '1' ? ' rwd noNews noHead' : '');
		}
		else {
			let rwd = Config.appConfig.SwitchRWDTab ? " rwd" : "";
			css = SelectedTab + ((realWebSkinType === '3' || realWebSkinType === '2' || realWebSkinType === '6') ? rwd : '') + (realWebSkinType === '1' ? ' rwd noNews noHead' : '');
		}

		setBodyCss(css, Config.appConfig.UserLang);
	};

	const goToGalaxy = () => {
		redirectToGalaxy({
			key: '7',
			sportId : 1,
		});
	}

	const goToMars = () => {
		setToKafka(1, 1, "AthenaSite_Behavior");
		redirectToMars({
			key: '8',
			sportId : 1,
		});
	}

	const closeJupiterPromotion = () => {
		setToKafka(1, 2, "AthenaSite_Behavior");
		setIsShowJupiterPromotion(false);
		document.body.style.backgroundPositionY = "";
		localStorage.setItem("_doNotShowJupiterPromotion", "1");
	}

	const sportActPara = ActPara + gid;
	return (
		<>
			{
				isShowJupiterPromotion ?
					<div class="new-version-container">
						<div class="new-version-stars new-version-floating"></div>
						<div class="new-version-candy" />
						<div class="new-version-title">
							{Label.lbl_Ju_NewViewPopup10}
						</div>
						{
							hasMars &&
							<div
								onClick={goToMars}
								class="new-version-button"
							>
								{Label.lbl_Ju_NewViewPopup11}
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none" viewBox="0 0 17 16">
									<path fill="#fff" d="M5.446 2.947a.951.951 0 0 0 0 1.347L9.152 8l-3.706 3.707a.952.952 0 1 0 1.347 1.346l4.385-4.384a.951.951 0 0 0 0-1.347L6.793 2.938a.96.96 0 0 0-1.347.009Z" />
								</svg>
							</div>
						}
						<div class="new-version-star new-version-floating"></div>
						<div
							onClick={closeJupiterPromotion}
							class="new-version-close"
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
								<path fill="#000" fill-opacity=".54" d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Z" />
								<path fill="#fff" d="M17.711 7.682a.986.986 0 0 0-1.393-1.393L12 10.606 7.682 6.29A.985.985 0 1 0 6.29 7.682L10.606 12 6.29 16.318a.986.986 0 0 0 1.393 1.393L12 13.394l4.318 4.317a.986.986 0 0 0 1.393-1.393L13.394 12l4.317-4.318Z"></path>
							</svg>
						</div>
					</div> :
					null
			}
			<div className="full-width" onKeyDown={handleKeyDown}>
				<div className='wrapper'>
					{Logined && <UMPopup />}
					<header>
						{enableTabComponent("Header") &&
							<Header IndexPage={Config.appConfig.IndexPage} />}
						{enableTabComponent("MainMenu") &&
							<MainMenu
								selectedTab={SelectedTab}
								selectTab={selectTab}
								menuItems={Config.appConfig.MenuData}
							/>}
					</header>
					{isAthena && !Logined && (enableTabComponent("Login") || enableTabComponent("LoginButtons")) && (
						<Login3
							popupDiv={popupDiv}
							enableLogin={enableTabComponent("Login")}
							enableloginButtons={enableTabComponent("LoginButtons")}
						/>
					)}
					{isAthena && Logined && enableTabComponent("Logout") && (
						<TopNavigation
							openDepositPage={openDepositPage}
							webSkinType={WebSkinType}
							popupDiv={popupDiv}
						/>
					)}

					{enableTabComponent("Time") && isShowTimeAndNews() && <Time />}
					{enableTabComponent("News") && isShowTimeAndNews() && <News />}
					{enableTabComponent("Sportsbook") &&
						<Sportsbook
							isAthena={isAthena}
							paraConfig={sportActPara}
							webSkinType={WebSkinType}
							siteBrand={Config.appConfig.SiteBrand}
							popupDiv={popupDiv}
							showBanner={false}
							promoNewVersionIsShow={false}
							openDivType={OpenDivType}
						/>}
					{isAthena && enableTabComponent("RingCasinoLobby") &&
						<RingCasinoLobby
							menuItems={Config.appConfig.MenuData}
							SelectedTab={SelectedTab}
							WebSkinType={WebSkinType}
						/>}
					{isAthena && enableTabComponent("Visual2") && Config.appConfig.VisualList &&
						<Visual2
							visualList={Config.appConfig.VisualList.Content.Table}
							Type="1"
						/>}
					{isAthena && enableTabComponent("CustBlock") &&
						<CustBlock MenuData={Config.appConfig.MenuData} />}
					{isAthena && enableTabComponent("Products") && Config.appConfig.DataComList && Config.appConfig.DataComList.AthenaTemplate.Products &&
						<Products
							productList={Config.appConfig.DataComList.AthenaTemplate.Products.Table}
							popupDiv={popupDiv}
							actPara={set_ActPara}
						/>}
					{isAthena && enableTabComponent("Casino") &&
						<Casino
							popupDiv={popupDiv}
							Type="1"
							Logined={Logined}
							ActStatus={Config.appConfig.ActStatus}
							Label={Label}
							DataComList={Config.appConfig.DataComList}
							CasinoVisualList={Config.appConfig.CasinoVisualList}
						/>}
					{isAthena && enableTabComponent("CasinoProducts") && Config.appConfig.DataComList && Config.appConfig.DataComList.AthenaTemplate.CasinoProduct &&
						<CasinoProducts
							casinoProduct={Config.appConfig.DataComList.AthenaTemplate.CasinoProduct.Table}
							popupDiv={popupDiv}
							Logined={Logined}
							ActStatus={Config.appConfig.ActStatus}
							Label={Label}
						/>}
					{isAthena && enableTabComponent("Footer") &&
						<Footer
							SiteTitle={Config.appConfig.SiteTitle}
							Label={Label}
						/>}
					{isAthena && enableTabComponent("CusFooter") &&
						<CusFooter
							FooterData={Config.appConfig.FooterData}
						/>}
					{isAthena && enableTabComponent("FooterDemo") &&
						<FooterDemo
							SiteTitle={Config.appConfig.SiteTitle}
							Label={Label}
						/>}
					{isAthena && enableTabComponent("livechatWidget") &&
						<LiveChatWidgetWrap popupDiv={popupDiv} />}

					{WebSkinType === '0' && SelectedTab.toLowerCase() === 'tab02' && <PhaseOut />}

					{OpenDivType === 0 && <Signup popupDiv={popupDiv} />}
					{OpenDivType === 1 && <Forget popupDiv={popupDiv} />}
					{OpenDivType === 2 && <LoginModal popupDiv={popupDiv} />}
					{OpenDivType === 3 && <PopCongra popupDiv={popupDiv} />}
					{OpenDivType === 4 && <TurnMobile popupDiv={popupDiv} />}
					{OpenDivType === 6 && <TransBar popupDiv={popupDiv} />}
					{OpenDivType === 7 && <PopupKycReupload popupDiv={popupDiv} />}
					<Alert />

				</div>
				{isRestricted() && ShowBrowserUpgrade && <BrowserRestrictWarning lang={Config.appConfig.UserLang} toggle={() => { setBrowserUpgrade(false) }} />}
				{isAthena && enableTabComponent("Out_Visual2") && Config.appConfig.VisualList &&
					<Out_Visual2 visualList={Config.appConfig.VisualList.Content.Table} Type="2" />}
				{isAthena && enableTabComponent("Out_Products") && Config.appConfig.DataComList && Config.appConfig.DataComList.AthenaTemplate.Products &&
					<Out_Products productList={Config.appConfig.DataComList.AthenaTemplate.Products.Table} popupDiv={popupDiv} actPara={set_ActPara} />}
				{isAthena && enableTabComponent("Out_Casino") &&
					<Out_Casino
						popupDiv={popupDiv}
						Type="2"
						Logined={Logined}
						ActStatus={Config.appConfig.ActStatus}
						Label={Label}
						DataComList={Config.appConfig.DataComList}
						CasinoVisualList={Config.appConfig.CasinoVisualList}
					/>}
				{isAthena && enableTabComponent("Out_Footer") &&
					<Out_Footer
						SiteTitle={Config.appConfig.SiteTitle}
						Label={Label}
					/>}
				{isAthena && enableTabComponent("Out_CusFooter") &&
					<Out_CusFooter
						FooterData={Config.appConfig.FooterData}
					/>}

				{
					Config.appConfig.EnableChinaViewTerminate && WebSkinType == '2' && OpenDivType === -1 && <ChinaviewTerminate></ChinaviewTerminate>
				}
				<div style={{ display: "none" }} id="clickBtnBySkinType" />
				<div style={{ display: "none" }} id="clickBtnByPopupType" />
				<div style={{ display: "none" }} id="clickBtnByOpenDeposit" />
				<div style={{ display: "none" }} id="clickBtnByStopLoginCheckin" />
				<div style={{ display: "none" }} id="clickBtnByChangeLanguage" />
				<div style={{ display: "none" }} id="clickBtnByDeepLink" />
				<div style={{ display: "none" }} id="clickBtnByChangeOddsType" />
				<div style={{ display: "none" }} id="clickBtnByChangeDarkmode" />
				<div style={{ display: "none" }} id="clickBtnByOpenKeno" />
				<div style={{ display: "none" }} id="clickBtnByOpenKenoLotterty" />
				<div style={{ display: "none" }} id="clickBtnByOpenKenoTableGame" />
			</div>
		</>
	);
}

ReactDOM.render(<AthenaAppMain />, document.getElementById("athenaMainContainer"));
